export const FIELD_PATTERN = {
    EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    TEXT: /^[a-zA-Z\s]*$/,
    TEXT_AND_SPACE: /^[a-z A-Z\s]*$/,
    NUMBER: /^[0-9]*$/,
};

const CVC_PATTERN_3_NUMBER = /^(\d{3})$/;
const CVC_PATTERN_3_4_NUMBER = /^(\d{3,4})$/;

export const LOGON_ID_STORE = '12001|';

export const CARD_VALIDATION = {
    generic: {
        type: 'generic',
        format: /(\d{1,4})/g,
        length: [13, 15, 16],
        minLength: 13,
        maxLength: 16,
        cvcLength: [3, 4],
        cvcPattern: CVC_PATTERN_3_4_NUMBER,
        luhn: true,
        payMethodId: 'CyberSource',
    },
    Amex: {
        type: 'Amex',
        pattern: /^3[47]/,
        format: /^3[47][0-9]{13}$/,
        formatObfuscated: /^3[47].{13}$/,
        length: [15],
        minLength: 15,
        maxLength: 15,
        cvcLength: [3, 4],
        cvcPattern: CVC_PATTERN_3_4_NUMBER,
        luhn: true,
        payMethodId: 'Amex',
    },
    Visa: {
        type: 'Visa',
        pattern: /^4/,
        format: /^4[0-9]{12}(?:[0-9]{3})?$/,
        formatObfuscated: /^4.{12}(?:.{3})?$/,
        length: [13, 16],
        minLength: 13,
        maxLength: 16,
        cvcLength: [3],
        cvcPattern: CVC_PATTERN_3_NUMBER,
        luhn: true,
        payMethodId: 'Visa',
    },
    Mastercard: {
        type: 'Mastercard',
        pattern: /^5[0-5]/,
        format: /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/,
        formatObfuscated:
            /^(5[1-5].{14}|2(22[1-9].{12}|2[3-9].{13}|[3-6].{14}|7[0-1].{13}|720.{12}))$/,
        length: [16],
        minLength: 16,
        maxLength: 16,
        cvcLength: [3],
        cvcPattern: CVC_PATTERN_3_NUMBER,
        luhn: true,
        payMethodId: 'Master Card',
    },
    Discover: {
        type: 'Discover',
        pattern: /^6([045]|22)/,
        format: /^(?:6011\d{12})|(?:65\d{14})$/,
        formatObfuscated: /^(?:6011.{12})|(?:65.{14})$/,
        length: [16],
        minLength: 16,
        maxLength: 16,
        cvcLength: [3],
        cvcPattern: CVC_PATTERN_3_NUMBER,
        luhn: true,
        payMethodId: 'Discover',
    },
    JCB: {
        type: 'JCB',
        pattern: /^35/,
        format: /^(?:2131|1800|35\d{3})\d{11}$/,
        formatObfuscated: /^(?:2131|1800|35\d{3}).{11}$/,
        length: [16],
        minLength: 16,
        maxLength: 16,
        cvcLength: [3],
        cvcPattern: CVC_PATTERN_3_NUMBER,
        luhn: true,
        payMethodId: 'JCB',
    },
};

export const SKELETON = {
    speed: 2,
    backgroundColor: '#d9d9d9',
};

// MY PRESCRIPTIONS IMPORT

export const defaultPd = 63;
export const smallPdAll = 55;
export const highPdAll = 76;
export const smallPdTwo = 27;
export const highPdTwo = 38;

export const prescriptionDefaults = {
    sphMin: -20,
    sphMax: 20,
    sphRes: 0.25,
    cylMin: -20,
    cylMax: 20,
    cylRes: 0.25,
    addMin: 0,
    addMax: 5,
    addMinFrame: 0.75,
    addMaxFrame: 4,
    addRes: 0.25,
    pdHalfMin: 25,
    pdHalfMax: 38,
    pdHalfRes: 1,
    pdMin: 51,
    pdMax: 77,
    pdRes: 0.5,
    axisMin: 0,
    axisMax: 180,
    axisRes: 10,
    pdSphRangeMin: -3,
    pdSphRangeMax: 3,
    prismVertMin: 0.5,
    prismVertMax: 5,
    prismVertRes: 0.25,
    prismBaseVert: ['Up', 'Down'],
    prismHorMin: 0.5,
    prismHorMax: 5,
    prismHorRes: 0.25,
    prismBaseHor: ['In', 'Out'],
};

export const PRESCRIPTION_DEFAULT_NICKNAME: string = 'Default Nickname';

export const INITIAL_PRESCRIPTIONS_DISPLAY_NUMBER = 4;

export enum PrescriptionProductCategory {
    GLASSES = 'GLASSES',
    CONTACTS = 'CONTACTS',
}

export enum PrescriptionClass {
    MY_ACCOUNT = 'MY_ACCOUNT',
    ORDER = 'ORDER',
}

export enum PrescriptionOrigin {
    MANUAL = 'MANUAL',
    DOCTOR = 'doctor',
}

export enum PrescriptionOriginMode {
    RXC_PRESCRIPTION = 'rxcPrescription',
    UPLOAD_PRESCRIPTION = 'uploadPrescription',
    CALL_DOCTOR = 'callDoctor',
}

export const MANUAL_PRESCRIPTION_DEFAULT_DOCTOR = 'web submission'
